// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"ae2aeb12","197":"ff24c2d5","429":"d7d9f832","468":"9809bc55","500":"57e6cbd7","883":"654aeebf"}[chunkId] + ".chunk.js";
};